var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", "max-width": "900px" } },
    [
      _c(
        "v-container",
        { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { staticClass: "pl-4 pt-4", attrs: { dense: "", flat: "" } },
                [
                  _c("v-icon", { staticClass: "mr-2 ml-0" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.readOnly
                            ? "mdi-text-box-search-outline"
                            : "mdi-file-upload-outline"
                        ) +
                        " "
                    )
                  ]),
                  _c("v-toolbar-title", { staticClass: "title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.readOnly
                            ? "Contract Upload Details"
                            : "Upload Contract"
                        ) +
                        " "
                    )
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "ml-auto pr-1", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "white--text",
                          attrs: {
                            loading: _vm.downloading,
                            disabled: _vm.downloading,
                            color: _vm.readOnly ? "primary" : "info"
                          },
                          on: {
                            click: function($event) {
                              _vm.readOnly
                                ? _vm.downloadContract()
                                : _vm.downloadTemplate(_vm.is_complex)
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-file-download-outline")
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.readOnly ? "Contract File" : "Template"
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.readOnly
                    ? _c(
                        "v-col",
                        { staticClass: "pr-0", attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                loading: _vm.loading,
                                disabled: _vm.uploadDisabled
                              },
                              on: { click: _vm.uploadFile }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-file-upload-outline")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.reupload ? "Reupload" : "Upload") +
                                  " "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    { staticClass: "pr-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("closeUpload")
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "py-4" },
                [
                  _c(
                    "v-container",
                    { staticClass: "pb-0 pt-0", attrs: { fluid: "" } },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "pt-0 mt-0 pl-2 ml-2",
                          staticStyle: { color: "grey", "font-size": "16px" }
                        },
                        [_vm._v(" " + _vm._s(_vm.modalSubtitle) + " ")]
                      ),
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "overflow: auto",
                                  attrs: { cols: "4" }
                                },
                                [
                                  _vm.readOnly
                                    ? [
                                        _c("v-text-field", {
                                          attrs: {
                                            inert: _vm.readOnly,
                                            label: "File Name",
                                            dense: "",
                                            readonly: "",
                                            "hide-details": "",
                                            "prepend-icon": "mdi-paperclip"
                                          },
                                          model: {
                                            value:
                                              _vm.selectedContract.file_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedContract,
                                                "file_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selectedContract.file_name"
                                          }
                                        })
                                      ]
                                    : [
                                        _c("v-file-input", {
                                          attrs: {
                                            inert: _vm.readOnly,
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "auto",
                                            "truncate-length": "100",
                                            label: "File*",
                                            clearable: "",
                                            rules: [
                                              function(v) {
                                                return !!v || "Required field"
                                              }
                                            ],
                                            accept: ".xlsx"
                                          },
                                          on: { change: _vm.handleFile },
                                          model: {
                                            value: _vm.file,
                                            callback: function($$v) {
                                              _vm.file = $$v
                                            },
                                            expression: "file"
                                          }
                                        })
                                      ]
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pr-4", attrs: { cols: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Promo Name",
                                      rules: [
                                        function(v) {
                                          return !!v || "Required field"
                                        },
                                        _vm.validateText
                                      ],
                                      dense: "",
                                      outlined: !_vm.readOnly,
                                      readonly: _vm.readOnly,
                                      inert: _vm.readOnly,
                                      "hide-details": "auto"
                                    },
                                    model: {
                                      value: _vm.product_line,
                                      callback: function($$v) {
                                        _vm.product_line = $$v
                                      },
                                      expression: "product_line"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-container",
                            { staticClass: "px-4 pb-0", attrs: { fluid: "" } },
                            [
                              _c(
                                "v-row",
                                { staticClass: "pb-2", attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c("VendorSingleSelect", {
                                        attrs: {
                                          readOnly: _vm.readOnly,
                                          value: _vm.payload.vendor_party_id
                                        },
                                        on: {
                                          "update:value": function($event) {
                                            return _vm.$set(
                                              _vm.payload,
                                              "vendor_party_id",
                                              $event
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c("ContractAdGroups", {
                                        attrs: {
                                          value: _vm.payload.ad_group_party_ids,
                                          manuallyAdded: _vm.manuallyAdded,
                                          readOnly: _vm.readOnly,
                                          reupload: _vm.reupload,
                                          adDatesSelected: _vm.adDatesSelected
                                        },
                                        on: {
                                          "update:value": function($event) {
                                            return _vm.$set(
                                              _vm.payload,
                                              "ad_group_party_ids",
                                              $event
                                            )
                                          },
                                          "update:manuallyAdded": function(
                                            $event
                                          ) {
                                            _vm.manuallyAdded = $event
                                          },
                                          "update:manually-added": function(
                                            $event
                                          ) {
                                            _vm.manuallyAdded = $event
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-divider", { staticClass: "my-2" }),
                              !_vm.is_complex
                                ? _c(
                                    "v-row",
                                    [
                                      _vm.readOnly ||
                                      !_vm.payload.tpr_non_allowance
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "2" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Ad Fee",
                                                  type: "number",
                                                  min: "0.00",
                                                  step: ".01",
                                                  prefix: "$",
                                                  disabled:
                                                    _vm.readOnly &&
                                                    !_vm.payload
                                                      .lump_sum_allowance,
                                                  readonly:
                                                    _vm.readOnly &&
                                                    _vm.payload
                                                      .lump_sum_allowance !=
                                                      null,
                                                  outlined: !_vm.readOnly,
                                                  dense: "",
                                                  "hide-details": "auto"
                                                },
                                                model: {
                                                  value:
                                                    _vm.payload
                                                      .lump_sum_allowance,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.payload,
                                                      "lump_sum_allowance",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "payload.lump_sum_allowance"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "2" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "TPR Fee",
                                              type: "number",
                                              min: "0.00",
                                              step: ".01",
                                              prefix: "$",
                                              disabled:
                                                _vm.readOnly &&
                                                !_vm.payload.tpr_fee,
                                              readonly:
                                                _vm.readOnly &&
                                                _vm.payload.tpr_fee != null,
                                              outlined: !_vm.readOnly,
                                              dense: "",
                                              "hide-details": "auto"
                                            },
                                            model: {
                                              value: _vm.payload.tpr_fee,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.payload,
                                                  "tpr_fee",
                                                  $$v
                                                )
                                              },
                                              expression: "payload.tpr_fee"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.is_complex
                                ? _c(
                                    "v-row",
                                    _vm._l(_vm.contractBoolsConfig, function(
                                      obj
                                    ) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: obj.value,
                                          staticClass: "mx-0 pr-0",
                                          attrs: {
                                            "align-self": "center",
                                            cols: "auto"
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-auto",
                                            attrs: {
                                              label: obj.label,
                                              color: "primary",
                                              dense: "",
                                              readonly:
                                                _vm.readOnly &&
                                                _vm.payload["" + obj.value] ===
                                                  true,
                                              disabled:
                                                (_vm.readOnly &&
                                                  !_vm.payload[
                                                    "" + obj.value
                                                  ]) ||
                                                obj.disabled,
                                              inert: _vm.readOnly,
                                              "hide-details": "",
                                              ripple: false
                                            },
                                            model: {
                                              value:
                                                _vm.payload["" + obj.value],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.payload,
                                                  "" + obj.value,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "payload[`${obj.value}`]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                : _vm._e(),
                              _vm.is_complex
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.complexPromoCategories,
                                              "item-text": "name",
                                              "item-value": "id",
                                              "item-color": "action",
                                              label: "Complex Promo Category",
                                              clearable: !_vm.readOnly,
                                              disabled:
                                                _vm.readOnly &&
                                                !_vm.payload
                                                  .complex_promo_category_id,
                                              readonly:
                                                _vm.readOnly &&
                                                Boolean(
                                                  _vm.payload
                                                    .complex_promo_category_id
                                                ),
                                              rules: [
                                                function(v) {
                                                  return !!v || "Required field"
                                                }
                                              ],
                                              inert: _vm.readOnly,
                                              "background-color": "#fff",
                                              dense: "",
                                              outlined: !_vm.readOnly,
                                              "hide-details": "auto"
                                            },
                                            model: {
                                              value:
                                                _vm.payload
                                                  .complex_promo_category_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.payload,
                                                  "complex_promo_category_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "payload.complex_promo_category_id "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            "align-self": "center",
                                            cols: "auto"
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-auto",
                                            attrs: {
                                              label: "DSD",
                                              color: "primary",
                                              dense: "",
                                              readonly:
                                                _vm.readOnly && _vm.payload.dsd,
                                              disabled:
                                                _vm.readOnly &&
                                                !_vm.payload.dsd,
                                              inert: _vm.readOnly,
                                              "hide-details": "",
                                              ripple: false
                                            },
                                            model: {
                                              value: _vm.payload.dsd,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.payload,
                                                  "dsd",
                                                  $$v
                                                )
                                              },
                                              expression: "payload.dsd"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("v-divider", { staticClass: "my-2" }),
                              _c(
                                "v-row",
                                { staticClass: "pt-2", attrs: { dense: "" } },
                                _vm._l(_vm.contractDatesConfig, function(
                                  config
                                ) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: config.value,
                                      class: _vm.readOnly ? undefined : "py-2",
                                      attrs: { cols: config.cols || 4 }
                                    },
                                    [
                                      _c("ContractDates", {
                                        ref: config.value + "_dates",
                                        refInFor: true,
                                        attrs: {
                                          value: _vm.payload["" + config.value],
                                          readOnly: _vm.readOnly,
                                          config: config,
                                          specialAdLength:
                                            _vm.payload.special_ad_length,
                                          ad_billback_category_id:
                                            _vm.payload.ad_billback_category_id,
                                          pcaf_promo_category_id:
                                            _vm.payload.pcaf_promo_category_id,
                                          isComplex: _vm.is_complex,
                                          "hide-details": "auto",
                                          error: _vm.showDateError
                                        },
                                        on: {
                                          "update:value": function($event) {
                                            return _vm.$set(
                                              _vm.payload,
                                              "" + config.value,
                                              $event
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.dialog
        ? _c("UploadDialog", {
            attrs: { file: _vm.file },
            on: {
              cancel: _vm.closeUploadDialog,
              confirmUpload: _vm.confirmUpload
            },
            model: {
              value: _vm.dialog,
              callback: function($$v) {
                _vm.dialog = $$v
              },
              expression: "dialog"
            }
          })
        : _vm._e(),
      _vm.confirmDatesDialog
        ? _c("ConfirmDatesDialog", {
            attrs: {
              pastDates: _vm.pastDates,
              tprDatesLessThanThreeWeeks: _vm.tprDatesLessThanThreeWeeks,
              tprStartDate: _vm.payload["tpr"].start_dt,
              tprEndDate: _vm.payload["tpr"].end_dt
            },
            on: {
              cancel: _vm.closeConfirmDatesDialog,
              openConfirm: _vm.confirmDates
            },
            model: {
              value: _vm.confirmDatesDialog,
              callback: function($$v) {
                _vm.confirmDatesDialog = $$v
              },
              expression: "confirmDatesDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }